// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"babcc2e4","160":"f8bc2cb8","208":"d423f425","293":"d7ee9fa7","453":"7e2449b1","516":"1b5d2c49","519":"c2c2182d","917":"6642d599","946":"01606f32"}[chunkId] + ".chunk.js";
};